import {AxiosInstance} from "axios";
import {v4 as uuidv4} from "uuid";

export const createAxiosInstanceProxy = (getInternalInstance: () => AxiosInstance | undefined): AxiosInstance => {
  return new Proxy({} as AxiosInstance, {
    get(target, prop) {
      const instance = getInternalInstance();
      if (!instance) {
        throw new Error("Axios instance is not initialized. Make sure the ApiManager is mounted.");
      }
      return instance[prop as keyof AxiosInstance];
    },
  });
};

export const addRequestIdToQuery = (axiosInstance: AxiosInstance): void => {
  axiosInstance.interceptors.request.use((config) => {
    const requestId = uuidv4();

    const url = new URL(config.url ?? "", config.baseURL);
    url.searchParams.set("request_id", requestId);

    config.url = url.pathname + url.search;
    return config;
  });
};

export const setAuthTokenInHeader = (token: string | null | undefined, instances: AxiosInstance[]): void => {
  for (const instance of instances) {
    if (token) {
      instance.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    } else {
      delete instance.defaults.headers.common["Authorization"];
    }
  }
};
